<template>
  <div
    :class="[
      'card-picker-card',
      'smooth-shadow',
      { 'width-large': large },
      { 'width-medium': medium },
    ]"
  >
    <div class="contents">
      <slot />
    </div>
    <div class="footer">
      <Button
        :type="'secondary'"
        @click="$emit('onClickCancel')"
        icon="clear"
        text="Cancel"
      />
      <Button
        :type="'primary'"
        @click="$emit('onClickApply')"
        text="Apply"
        icon="check"
      />
    </div>
  </div>
</template>

<script>
import Button from "@/components/global/views/Button";

export default {
  props: {
    large: Boolean,
    medium: Boolean,
  },
  components: {
    Button,
  },
};
</script>

<style lang="scss" scoped>
.card-picker-card {
  width: 90%;
  max-width: 800px;
  height: auto;
  max-height: 900px;
  background: var(--color-secondary);
  border-radius: 5px;
  display: flex;
  flex-direction: column;
  transition: 0.3s max-height ease-in-out;

  &.width-large {
    max-width: 800px;
  }

  &.width-medium {
    max-width: 500px;
  }

  .contents {
    display: flex;
    flex: 1;
    flex-direction: column;
    padding: 15px;
  }

  .footer {
    background-color: var(--color-default-background);
    display: flex;
    align-items: center;
    justify-content: flex-end;
    border-radius: 0 0 5px 5px;
    padding: 10px;
  }
}
</style>
